"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const FeatureTogglesControlPanel = require("./FeatureTogglesControlPanel/FeatureTogglesControlPanel/FeatureTogglesControlPanel.js");
exports.FeatureTogglesControlPanel = FeatureTogglesControlPanel.FeatureTogglesControlPanel;
//# sourceMappingURL=index.js.map
